import React, { useContext } from 'react'

import type { RecipeGridContentBlock } from '@library/api-menu-experience'
import { RecipeGrid } from '@library/menu-page'
import type { RecipeUUID } from '@library/menu-service'

import { useSetBrowserCTAVisibility } from 'routes/Menu/domains/menu'

import { MenuBrandingContext } from '../menuBrandingContext'
import { useMenuExperienceRecipeDetails } from '../menuExperienceRecipeDetailContext'
import { useRecipeGridBasket } from './useRecipeGridBasket'

type RecipeGridContentBlockWrapperProps = {
  contentBlock: RecipeGridContentBlock
}

export const RecipeGridContentBlockWrapper = ({
  contentBlock,
}: RecipeGridContentBlockWrapperProps) => {
  const { textColor } = useContext(MenuBrandingContext)
  const { openRecipeDetail } = useMenuExperienceRecipeDetails()
  const { setBrowserCTAVisible } = useSetBrowserCTAVisibility()
  const { getRecipeTileState, onAddClick, onRemoveClick } = useRecipeGridBasket(contentBlock.items)

  const onRecipeClick = (recipeId: RecipeUUID, recipePosition: number) => {
    const recipe = contentBlock.items.find((item) => item.id === recipeId)

    if (!recipe) {
      return
    }

    openRecipeDetail({
      recipeId,
      title: recipe.title,
      position: recipePosition.toString(),
      source: 'recipe_grid',
    })
  }

  return (
    <RecipeGrid
      contentBlock={contentBlock}
      recipeCountTextColor={textColor}
      getRecipeTileState={getRecipeTileState}
      onRecipeClick={onRecipeClick}
      onAddClick={onAddClick}
      onRemoveClick={onRemoveClick}
      onBlockedAddAttempt={setBrowserCTAVisible}
    />
  )
}
